















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ChipsResponse } from '@/constants/form/types';

@Component({})
export default class Chips extends Vue {
  // チップス内に表示するテキスト
  @Prop({ default: '' })
  private text!: string;
  // チップスを押下したことを判別する値
  @Prop({ default: '' })
  private value?: string;
  // チップス本体の色 (参考：https://vuetifyjs.com/ja/styles/colors/#sass-)
  @Prop({ default: '' })
  private color?: string;
  // チップス内テキスト色 (参考：https://vuetifyjs.com/ja/styles/colors/#sass-)
  @Prop({ default: '' })
  private textColor?: string;
  // チップスに閉じるイベント付与
  @Prop({ default: false })
  private close?: boolean;
  // チップス内にアイコンを表示する (参考：https://materialdesignicons.com/)
  @Prop({ default: '' })
  private icon?: string;
  // チップスに枠線付与
  @Prop({ default: false })
  private outlined?: boolean;
  // チップスの表示status (閉じるイベントが付与されている際使用)
  private chip = true;

  /**
   * 親コンポーネントに押下したか否か通知する
   * @module isPushChips
   * @return {[k: string]: boolean} - Chipを押下したか否か
   */
  @Emit('isPushChips')
  public isPushChips(): ChipsResponse {
    return {value: this.value};
  }
}
